/**
 * Detects whether the web app is running inside the SparkPlug native shell (iOS/Android).
 * The native WebView appends "SparkPlugNativeApp" to the user-agent string.
 */
export const isNativeApp = (): boolean => {
    return typeof navigator !== 'undefined' && navigator.userAgent.includes('SparkPlugNativeApp');
};
